import React from "react";
import { OpenSpaceContainer } from "../../components/OpenSpace";

export const OpenSpacePage = () => {
  return <OpenSpaceContainer />;
};
